import React from "react";
import {ResultsPowerBiView } from "./results-powerbi-view";
export const ResultsPowerBiController = (props) => {
  return (
    <>
      <ResultsPowerBiView {...props} />
    </>
  );
};
